<template>
  <div class="home">
    <Oclock class="logo a-flipinX" width="320px" height="320px" />
    <div class="application">
      <QQGroupLink class="item a-flipinX" />
      <BilibiliLiveLink class="item a-flipinX" :roomID="$t('info.live_room_id')" />
      <BilibiliGroupLink class="item a-flipinX" />
    </div>
  </div>
</template>
clear
<script>
// @ is an alias to /src
import Oclock from "../components/Oclock.vue";
import BilibiliLiveLink from "../components/BilibiliLiveLink.vue";
import BilibiliGroupLink from "../components/BilibiliGroupLink.vue";
import QQGroupLink from "../components/QQGroupLink.vue";

export default {
  name: "Home",
  created() {
    document.title = `${this.$t("app.title")} ${this.$t("app.title_suffix")}`;
  },
  components: {
    Oclock,
    BilibiliLiveLink,
    BilibiliGroupLink,
    QQGroupLink
  }
};
</script>
<style lang="less">
.home {
  .logo {
    margin: 0 auto;
  }
  .application {
    display: flex;
    max-width: 500px;
    margin: 0 auto;
    width: 100%;
    margin-top: 30px;
    .item {
      flex: 1;
    }
  }
}
</style>